import {h} from 'preact';

import {SITE_URL} from '@util/URLUtils';
import Button from '@components/common/Button';
import Icon from '@components/common/Icon';
import Message from '@components/common/Message';
import ProgressBar from '@components/registration/ProgressBar';

const AccountVerifiedNPI = ( props, context ) =>
    <div>

        <ProgressBar step={'3'} completed={[1, 1, 1]} labels={['create login', 'verify account', 'verified']} isSubmitted={props.location.state.isSubmitted}/>
                     
        <h1 className="font-light text-center text-2xl md:text-4xl regSubHeading mx-auto">All Done!</h1>
        <div className="leading-tight universalForm-container my-4 md:my-12 mx-auto">
            {context.state.signUpError &&
            <Message fail className="bg-fail flex font-normal items-center -ml-4 -mr-4 md:-ml-8 md:-mr-8 px-4 md:px-8 py-4 text-white w-auto mb-4">
                <Icon.ui wrapperClassName="mr-2" className="text-white text-xl"
                         name="report-problem-triangle"/>
                <span className="message-bar-msg">There was an error submitting this request, please try again.</span>
            </Message>
            }
            <Icon.ui
                className="items-center text-success text-5xl mb-4"
                wrapperClassName="justify-center"
                center
                name="checkmark-circle"
            />
            <p className="text-center font-normal mx-auto">Your account has been activated. You now have the
                ability to order products online, view your order history, request a return or equipment repair and
                register for seminars.</p>
            <p className="mt-8 text-center font-normal mx-auto">Also, be sure to <strong>sign up for the Ultradent
                Newsletter</strong> to receive extra promotions and more!</p>
            <p className="my-4 text-center text-lg">{props.location.state.emailAddress}</p>
            <Button onClick={!context.state.signUpSuccess ? context.signUp : null}
                    className={`full ${context.state.signUpSuccess ? 'success' : 'primary'}`}
                    loading={context.state.signUpLoading}
                    disabled={context.state.signUpSubmitting}>
                {context.state.signUpSuccess ? 'Thank You!' : 'Yes, sign me up!'}
            </Button>

            <div className="text-center">
                <a href={SITE_URL} className="block full link-2 mt-12">
                    Start Shopping
                </a>
            </div>
        </div>
    </div>;

export default AccountVerifiedNPI;